import { isPlainObject } from 'lodash';
export const isObject = (item) => isPlainObject(item);
